// What one tick on the playback rail represents. Determines both the tick labels and the readout
// format, so period and rail can never disagree.
enum PlaybackTimelineTickUnit {
  Hour,
  Weekday,
  Week,
}

export default PlaybackTimelineTickUnit;
